<template>
  <div class="bg-[#121419] text-white min-h-screen relative px-[20px]">
    <terms-inc />
  </div>
</template>

<script>
// @ is an alias to /src

import TermsInc from "@/components/includes/regionTermsInc";

export default {
  name: 'TermsView',
  components: {
    TermsInc
  },
  data() {

  }
}
</script>

<style lang="scss">
    .page-wrapper {
        padding-top: 5rem;
        display: flex;
        flex-direction: column;

        &--terms {
            background: #fff;
          color: #000000;
        }

      .text-formatted {
        width: 100%;
        max-width: 660px;
        margin-right: auto;
        margin-left: auto;

        font-size: 24px;
        line-height: 28.8px;
      }

      h2.cl-h1 {
        line-height: 100%;
      }
    }
</style>
